import { Link } from 'react-router-dom';
import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { testimonials, principles } from '@/mocks/about';

export default function VoiceSection() {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20 bg-background-100 border-y border-background-200">
      <SectionHeading
        eyebrow="About & Voices"
        title="我们如何整理这些爆料"
        desc="爆料专区导航是一个信息整理站点。我们把分散的入口与讨论区归拢到一处，标注来源与时间，把判断权留给读者。"
        align="center"
      />

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {principles.map((item, index) => (
          <Reveal key={item.id} delay={index * 50}>
            <article className="h-full bg-background-50 border border-background-200 rounded-lg p-6">
              <span className="w-11 h-11 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center text-xl">
                <i className={item.icon} />
              </span>
              <h3 className="font-heading mt-4 text-base font-semibold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </article>
          </Reveal>
        ))}
      </div>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
        {testimonials.map((voice) => (
          <figure key={voice.id} className="bg-background-50 border border-background-200 rounded-lg p-6 flex flex-col">
            <i className="ri-double-quotes-l text-3xl text-primary-300" />
            <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700 flex-1">
              {voice.content}
            </blockquote>
            <figcaption className="mt-5 pt-4 border-t border-background-200">
              <span className="block text-sm font-semibold text-foreground-950">{voice.name}</span>
              <span className="mt-0.5 block text-xs text-foreground-500">{voice.role}</span>
            </figcaption>
          </figure>
        ))}
      </div>

      <div className="mt-10 text-center">
        <Link
          to="/about"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-foreground-950 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          了解我们的定位与原则
          <i className="ri-arrow-right-line" />
        </Link>
      </div>
    </section>
  );
}